function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { merge, sum } from "d3-array";
import unique from "./unique.js";
/**
    Combines an Array of Objects together and returns a new Object.
    @param objects The Array of objects to be merged together.
    @param aggs An object containing specific aggregation methods (functions) for each key type. By default, numbers are summed and strings are returned as an array of unique values.
    @example <caption>this</caption>
merge([
  {id: "foo", group: "A", value: 10, links: [1, 2]},
  {id: "bar", group: "A", value: 20, links: [1, 3]}
]);
    @example <caption>returns this</caption>
{id: ["bar", "foo"], group: "A", value: 30, links: [1, 2, 3]}
*/ function objectMerge(objects) {
    var aggs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var availableKeys = unique(merge(objects.map(function(o) {
        return Object.keys(o);
    }))), newObject = {};
    availableKeys.forEach(function(k) {
        var value;
        if (aggs[k]) value = aggs[k](objects, function(o) {
            return o[k];
        });
        else {
            var values = objects.map(function(o) {
                return o[k];
            });
            var types = values.map(function(v) {
                return v || v === false ? v.constructor : v;
            }).filter(function(v) {
                return v !== void 0;
            });
            if (!types.length) value = undefined;
            else if (types.indexOf(Array) >= 0) {
                var flattened = merge(values.map(function(v) {
                    return _instanceof(v, Array) ? v : [
                        v
                    ];
                }));
                var merged = unique(flattened);
                value = merged.length === 1 ? merged[0] : merged;
            } else if (types.indexOf(String) >= 0) {
                var uniq = unique(values);
                value = uniq.length === 1 ? uniq[0] : uniq;
            } else if (types.indexOf(Number) >= 0) value = sum(values);
            else if (types.indexOf(Object) >= 0) {
                var filtered = unique(values.filter(function(v) {
                    return v;
                }));
                value = filtered.length === 1 ? filtered[0] : objectMerge(filtered);
            } else {
                var filtered1 = unique(values.filter(function(v) {
                    return v !== void 0;
                }));
                value = filtered1.length === 1 ? filtered1[0] : filtered1;
            }
        }
        newObject[k] = value;
    });
    return newObject;
}
export default objectMerge;

//# sourceMappingURL=merge.js.map